

































































































import {Component, Vue} from "vue-property-decorator";
import {AllSubscriptions_subscriptions} from "../../../shared/generated/AllSubscriptions";
import {Action, Getter, State} from "vuex-class";
import {PayPalSubscriptionApprove} from "@/types";
import {gMutate} from "@/services/graphql";
import {SubscriptionsGQL} from "@dynamoit/shared/src/queries/SubscriptionsGQL";
import {Subscribe, SubscribeVariables} from "../../../shared/generated/Subscribe";
import {CancelSubscription, CancelSubscriptionVariables} from "../../../shared/generated/CancelSubscription";

@Component
export default class Settings extends Vue {

    @State
    subscriptions!: AllSubscriptions_subscriptions[]

    @Getter
    hasActiveSubscriptions!: boolean

    @Action
    loadSubscriptions!: () => Promise<void>

    tab: any = null

    canceling = false

    showPaypalButtons() {
        const self = this
        setTimeout(() => {
            if (this.$refs.paypal) {
                (window as any).paypal.Buttons({
                    style: {
                        shape: 'rect',
                        color: 'gold',
                        layout: 'vertical',
                        label: 'subscribe'
                    },
                    createSubscription: function (data: any, actions: any) {
                        return actions.subscription.create({
                            plan_id: 'P-7JY47144SW357144GMFNWBLQ'
                        });
                    },
                    onApprove: async function (data: PayPalSubscriptionApprove) {
                        await gMutate<Subscribe, SubscribeVariables>(SubscriptionsGQL.SUBSCRIBE, {
                            id: data.subscriptionID,
                            orderId: data.orderID,
                            facilitatorAccessToken: data.facilitatorAccessToken
                        })
                        await self.loadSubscriptions()
                    },
                    onError: function () {
                        alert('Subscription error! Operation could not be completed.')
                    }
                }).render(this.$refs.paypal);
            } else {
                this.showPaypalButtons()
            }
        }, 100)
    }

    async onCancelSubscription(id: string) {
        try {
            this.canceling = true
            await gMutate<CancelSubscription, CancelSubscriptionVariables>(SubscriptionsGQL.CANCEL_SUBSCRIPTION, {id})
            await this.loadSubscriptions()
        } finally {
            this.canceling = false
        }
    }

    mounted() {
        this.showPaypalButtons()
    }

}
